import Vue from "vue";
import moment from "moment";

Vue.filter("formatDate", function (value) {
  if (value) {
    return moment(String(value)).format("DD/MM/YYYY");
  }
});

Vue.filter("formatTime", function (value) {
  if (value) {
    return moment(String(value)).format("HH:mm น.");
  }
});

Vue.filter("trimDetails", function (value) {
  if (value) {
    value = value.toString();
    return value.length > 50 ? value.substring(0, 50) + "..." : value;
  }
});

Vue.filter("formatDateAllow", function (value) {
  if (value) {
    return moment(String(value)).format("DD/MM/YYYY");
  }
});